// src/modules/app-views/account/pages/Subscription/actions/actionButton.js
import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { openModal } from 'components/core/GenericModal';
import RemoveSubscriptionModal from '../modals/RemoveSubscriptionModal';
import app from 'configs/appResolver';

const subscriptionActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: null,
    type: 'primary',
    disabled: false,

    // Primary button handler - uses moduleContext.formContext pattern
    onClick: ({ moduleContext }) => {
      moduleContext?.formContext?.submitForm?.();
    },

    // Dropdown configuration
    dropdownIcon: <SettingOutlined />,
    dropdownTooltip: 'more_options',
    dropdownDisabled: false,
    dropdownItems: [
      {
        key: 'removeSubscription',
        label: 'remove_subscription',
        icon: <DeleteOutlined />,
        danger: true,
        hidden: app.PRESET?.MULTI_SUBSCRIPTIONS === false,
        // NOTE: ActionButton passes 'page' not 'currentPage' in context
        disabled: ({ currentPage, page }) => {
          const pageData = currentPage || page;
          return !pageData?.data?._id;
        },
        onClick: async context => {
          await openModal(RemoveSubscriptionModal, { ...context });
        },
      },
    ],
  };
};

export default subscriptionActionButton;
